import { COST_SIMULATION_YEARS } from "@repo/shared";

// Local translations
export const T = {
  en_GB: {
    title: "Title (optional)",
    titlePlaceholder: "e.g., Cost Summary",
    titleHelp: "Optional heading to display above the cost table",
    description: "Description (optional)",
    descriptionPlaceholder: "Enter description...",
    descriptionHelp: "Optional text to display between the title and table",
    showHoldingPeriod: "Show holding-period column",
    showHoldingPeriodHelp:
      'Adds an "After N years" column next to the "After 1 year" figures (MiFID II holding-period cost disclosure).',
    holdingPeriodYears: "Holding period (years)",
    holdingPeriodYearsHelp: `Between 2 and ${COST_SIMULATION_YEARS} years`,
    componentDescription:
      "This component displays the aggregated cost effect after 1 year — deposits, expected value before and after cost, reduction in return — with an optional holding-period column.",
  },
  nb_NO: {
    title: "Tittel (valgfri)",
    titlePlaceholder: "f.eks. Kostnadsoversikt",
    titleHelp: "Valgfri overskrift som vises over kostnadstabellen",
    description: "Beskrivelse (valgfri)",
    descriptionPlaceholder: "Skriv inn beskrivelse...",
    descriptionHelp: "Valgfri tekst som vises mellom tittelen og tabellen",
    showHoldingPeriod: "Vis kolonne for investeringsperioden",
    showHoldingPeriodHelp:
      'Legger til en "Etter N år"-kolonne ved siden av tallene for "Etter 1 år" (MiFID II kostnadsopplysning for investeringsperioden).',
    holdingPeriodYears: "Investeringsperiode (år)",
    holdingPeriodYearsHelp: `Mellom 2 og ${COST_SIMULATION_YEARS} år`,
    componentDescription:
      "Denne komponenten viser samlet kostnadseffekt etter 1 år — innskudd, forventet verdi før og etter kostnader, reduksjon i avkastning — med en valgfri kolonne for investeringsperioden.",
  },
} as const;
